import { render } from "./XiaofeiData.vue?vue&type=template&id=5e49f35f&scoped=true"
import script from "./XiaofeiData.vue?vue&type=script&lang=js"
export * from "./XiaofeiData.vue?vue&type=script&lang=js"

import "./XiaofeiData.vue?vue&type=style&index=0&id=5e49f35f&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e49f35f"]])

export default __exports__